import * as Api from "@api";
import React from "react";
import { isReactNodeEmpty } from "../Utils";
import { PageContent } from "./PageContent";
import { Color } from '@/components';

type PageContentBlockItem = { node: React.ReactNode } | { props: Partial<typeof PageContent> };

export interface PageContentBlockProps<Keys extends readonly Api.ContentKey[]> extends Omit<React.ComponentProps<"div">, "children">
{
    keys: Keys;
    pageContent: Api.Content<Keys[number]>;
    items?: Partial<Api.PlainKeyedEntity<Keys[number], PageContentBlockItem>>;
    skipEmpty?: boolean;
    textColor?: Color | string;
}

export const PageContentBlock = <Keys extends readonly Api.ContentKey[]>({ keys, pageContent, items, skipEmpty, textColor, ...divProps }: PageContentBlockProps<Keys>): React.ReactComponentElement<"div", PageContentBlockProps<Keys>> | null =>
{
    let empty = true;

    const content = keys.map(key => 
    {
        const plainKey = Api.ContentService.getPlainKey(key as Keys[number]);

        let props: Partial<typeof PageContent> | undefined = undefined;

        if (items !== undefined)
        {
            const item = items[plainKey];
            if (item !== undefined)
            {
                if ("node" in item)
                {
                    const node = item.node;
                    empty &&= isReactNodeEmpty(node);
                    return node;
                }

                if ("props" in item)
                {
                    props = item.props;

                }

            }
        }
        const pc = Api.ContentService.getItem(pageContent, key);

        if (pc === undefined)
        {
            return null;
        }

        empty = false;
        return <PageContent key={plainKey} {...pc} {...props} textColor={textColor} />;

    });

    return skipEmpty && empty ? null : <div {...divProps}>{content}</div>;
}
